import getLocalSettingsProxy from '../../getLocalSettingsProxy';

/**
 * @method getBookPropertiesFromLocalSettings
 * @returns {Object} object containing a timestamp and a book primary key
 *                   or null if either property is unavailable
 */
const getBookPropertiesFromLocalSettings = () => {
  const localSettings = getLocalSettingsProxy();

  const { timestamp, pk } = localSettings.mostRecentBook;

  if (!timestamp || !pk) {
    return null;
  }

  return {
    timestamp: parseInt(timestamp),
    pk: parseInt(pk),
  };
};

export default getBookPropertiesFromLocalSettings;
